import React, { useContext, useState } from "react";
import AppContext from "../../../../../../context/AppContext";
import { useResources } from "../../../../../../context/ResourcesContext";
import UnfilledButton from "../../../../../molecules/buttons/unfilledButton/UnfilledButton";
import FilledButton from "../../../../../molecules/buttons/filledButton/FilledButton";

function RemoveResourceFromFolderModal({ removeFunction, isPlural, resourceDescription, onSuccess = () => {} }) {
  const { setModalVisible } = useContext(AppContext);
  const { isResourceMasculine, getResourceName } = useResources();

  const [isButtonLoading, setIsButtonLoading] = useState(false);

  async function removeResourceFromFolder() {
    setIsButtonLoading(true);

    await removeFunction();

    onSuccess();
    setModalVisible(false);
    setIsButtonLoading(false);
  }

  function getDynamicRemoveText() {
    if (isPlural)
      return `tou${isResourceMasculine(resourceDescription) ? "" : "te"}s les ${getResourceName(resourceDescription)} de votre dossier ? Cette action est irréversible et les supprimera également`;

    return `ce${isResourceMasculine(resourceDescription) ? "" : "tte"} ${getResourceName(resourceDescription)} de votre dossier ? Cette action est irréversible et l${isResourceMasculine(resourceDescription) ? "e" : "a"} retirera également ${getResourceName(resourceDescription, false, true)}`;
  }

  return (
    <>
      <p>Êtes-vous sûr de vouloir retirer {getDynamicRemoveText()} des livrables associés.</p>
      <div className='modal-buttons-row'>
        <UnfilledButton onClick={() => setModalVisible(false)} padding='10px 25px'>
          Annuler
        </UnfilledButton>
        <FilledButton isLoading={isButtonLoading} onClick={removeResourceFromFolder} padding='10px 25px'>
          Retirer du dossier
        </FilledButton>
      </div>
    </>
  );
}

export default RemoveResourceFromFolderModal;
